import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

// One shared long-poll loop for every subscriber (nav badge + page); runs only while something is mounted.
let data = null;
let users = 0;
let run = 0;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

async function loop(id) {
  while (id === run) {
    try {
      const { data: next } = await api.get("/admin/subscriptions", { params: { etag: data?.etag || "", wait: data ? 1 : 0 }, timeout: 30000 });
      if (id !== run) return;
      if (next.etag !== data?.etag) {
        data = next;
        emit();
      }
    } catch {
      await sleep(10000);
    }
  }
}

const subscribe = (l) => {
  listeners.add(l);
  users += 1;
  if (users === 1) loop(++run);
  return () => {
    listeners.delete(l);
    users -= 1;
    if (users === 0) run += 1;
  };
};

export const useSubscriptions = () => useSyncExternalStore(subscribe, () => data);
